export default __webpack_public_path__ + "3e6da50364eee37cf0eb66f9b1be9fc5.png";